import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const monthlyTourReportParamsSchema = object({
  monthlyTourReportId: stringToNumber()
})
